import { useEffect, useCallback, ReactNode } from 'react'

import type { ColorsResult } from 'app/common/api/requests/cabinet/colors'

import './color-theme-variables.scss'

/**
 *  Провайдер цветовой темы. Получает ключевые цвета с сервера и назначает их в CSS переменные
 */

type Props = {
  children: ReactNode
  onRequestTheme?: () => Promise<ColorsResult | null>
}

const ColorThemeProvider = ({ children, onRequestTheme }: Props) => {
  const applyTheme = useCallback((colors: ColorsResult) => {
    const root = document.documentElement
    if (root) {
      root.style.setProperty('--primary-color', colors['primary-color'])
      root.style.setProperty('--active-primary-color', colors['active-primary-color'])
      root.style.setProperty('--hover-primary-color', colors['hover-primary-color'])
      root.style.setProperty(
        '--subitem-active-primary-color',
        colors['subitem-active-primary-color'],
      )
      root.style.setProperty('--active-secondary-color', colors['active-secondary-color'])
      root.style.setProperty('--link-color', colors['link-color'])
      root.style.setProperty('--button-primary', colors['button-primary'])
      root.style.setProperty('--button-primary-hover', colors['button-primary-hover'])
    }
  }, [])

  useEffect(() => {
    if (onRequestTheme) {
      ;(async () => {
        const themeValues = await onRequestTheme()
        if (themeValues) {
          applyTheme(themeValues)
        }
      })()
    }
  }, []) // eslint-disable-line react-hooks/exhaustive-deps

  return children
}

export default ColorThemeProvider
